import { DestroyRef, inject, Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormControl, NonNullableFormBuilder } from '@angular/forms';
import { tap } from 'rxjs';
import { JSONContent } from '@tiptap/core';
import { FormValidators } from '@corelabs/angular/forms';
import { MediaType } from '@app/store/shared/models';

@Injectable()
export class MediaFormService {
    private readonly formBuilder = inject(NonNullableFormBuilder);
    private readonly destroyRef = inject(DestroyRef);

    readonly form = this.formBuilder.group({
        name: this.formBuilder.control('', [FormValidators.Required]),
        type: this.formBuilder.control<MediaType | null>(null, [FormValidators.Required]),
        mediaId: this.formBuilder.control<string | null>(null, [FormValidators.Required]),
        content: this.formBuilder.control<JSONContent | null>(null, [FormValidators.Required]),
        duration: new FormControl<number | null>(null),
    });

    constructor() {
        this.form.controls.type.valueChanges
            .pipe(
                tap((type) => this.onTypeChange(type)),
                takeUntilDestroyed(this.destroyRef),
            )
            .subscribe();
    }

    onTypeChange(type: MediaType | null): void {
        const { mediaId, content, duration } = this.form.controls;

        switch (type) {
            case 'text': {
                mediaId.disable();
                mediaId.reset();
                content.enable();
                duration.enable();
                break;
            }

            case 'video':
            case 'audio':
            case 'image':
            case 'pdf': {
                mediaId.enable();
                content.disable();
                content.reset();
                duration.disable();
                duration.reset();
                break;
            }

            default: {
                mediaId.disable();
                content.disable();
                duration.disable();
                break;
            }
        }
    }
}
